import React, { useContext } from 'react';
import MessagesContext from '../../../contexts/messagesContext';
import { makeStyles } from '@material-ui/core';
import { useParams } from 'react-router';
import { Link, useLocation } from 'react-router-dom';
import useCheckMobileScreen from '../../../hooks/useWidth';
import { useSelector } from 'react-redux';

const styles = makeStyles((theme) => ({
    row: {
        display: 'flex',
        background: '#fff',
        padding: '24px 24px 0 24px',
        [theme.breakpoints.down(1025)]: {
            padding: '10px 48px 2px 48px ',
            width: '100%'
            // borderBottom: 'solid 1px #e8ecf2'
        }
    },
    item: ({ disabled }) => ({
        flex: 1,
        borderBottom: 'solid 1.5px #ced2d6',
        textAlign: 'center',
        paddingBottom: '8px',
        fontFamily: 'inherit',
        fontSize: '13px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.69,
        letterSpacing: 'normal',
        color: '#545e66',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? '0.5' : '1',
        [theme.breakpoints.down(1025)]: {
            borderBottom: 'unset'
        }
    }),

    activeTab: {
        color: '#509ffa',
        position: 'relative',
        '&:before': {
            content: '""',
            position: 'absolute',
            width: '100%',
            height: '3px',
            backgroundColor: '#509ffa',
            borderRadius: '3px',
            bottom: '-2px',
            left: 0,
            right: 0,
            [theme.breakpoints.down(1025)]: {
                bottom: '-4px'
            }
        }
    }
}));

const TabBar = () => {
    const { messages } = useContext(MessagesContext);
    const allForms = useSelector((state) => state.dynamicForms?.allForms);
    const classes = styles({ disabled: !allForms?.length });
    const isMobile = useCheckMobileScreen();
    const { id, clinicId } = useParams();
    const { pathname } = useLocation();
    const { entries } = useSelector((state) => state.dynamicForms.formEntries);
    const defaultUrl = isMobile ? '' : entries?.length ? `/${entries[0]?.id}` : '/newForm';
    const name = pathname?.split('/').filter((item) => item)[4];

    const Tabs = [
        {
            id: 1,
            name: 'form',
            title: messages.forms,
            link: `/${clinicId}/patient/${id}/forms/form${defaultUrl}`
        },
        {
            id: 2,
            name: 'comparison',
            title: messages.comparison,
            link: `/${clinicId}/patient/${id}/forms/comparison`
        }
    ];
    const handleClickLink = (e) => {
        if (!allForms?.length) {
            e.preventDefault();
        }
    };
    return (
        <>
            <div className={classes.row}>
                {Tabs.map((item) => (
                    <Link
                        key={item.id}
                        to={item.link}
                        className={`${name === item.name && classes.activeTab} ${classes.item}`}
                        onClick={handleClickLink}
                    >
                        {item.title}
                    </Link>
                ))}
            </div>
        </>
    );
};

export default TabBar;
